import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { MatBottomSheet, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-close-btn',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatBottomSheetModule
  ],
  templateUrl: './close-btn.component.html',
  styleUrls: ['./close-btn.component.scss']
})
export class CloseBtnComponent {

  readonly dialog = inject(MatDialog);
  readonly sheet = inject(MatBottomSheet);

  @Input() top;
  @Input() right;
  @Input() bottom;
  @Input() left;
  @Input() type;
  @Output() closeBtnListner = new EventEmitter();

  close() {
    this.closeBtnListner.next(true);
    switch (this.type) {
      case 'dialog': this.dialog.closeAll(); break;
      case 'sheet': this.sheet.dismiss(); break;
      default: this.dialog.closeAll(); break;
    }
  }

}
